import { useBranches } from '../../lib/queries';
import { SearchSelect } from '../SearchSelect';

import type { CSSProperties } from 'react';

interface BranchSelectProps {
  companyId: string | undefined;
  value: string;
  onChange: (id: string) => void;
  required?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
  searchable?: boolean;
}

/**
 * Reusable สาขา (branch) picker bound to the active company's branch master.
 * Empty value = no branch selected. When `required` the placeholder option
 * nudges the user that a value must be picked (the server enforces the actual
 * policy via ChartOfAccount.branchPolicy).
 */
export function BranchSelect({
  companyId,
  value,
  onChange,
  required,
  disabled,
  style,
  searchable,
}: BranchSelectProps) {
  const { data: branches = [] } = useBranches(companyId, true);
  const placeholder = required ? '— เลือกสาขา * —' : '— สาขา —';

  if (searchable) {
    return (
      <SearchSelect
        value={value}
        onChange={onChange}
        disabled={disabled ?? false}
        placeholder={placeholder}
        options={branches.map((b) => ({ value: b.id, label: `${b.code} — ${b.nameTh}` }))}
        getLabel={(v) => {
          const b = branches.find((x) => x.id === v);
          return b ? `${b.code} — ${b.nameTh}` : '';
        }}
      />
    );
  }

  return (
    <select
      className="select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={style}
    >
      <option value="">{placeholder}</option>
      {branches.map((b) => (
        <option key={b.id} value={b.id}>
          {b.code} — {b.nameTh}
        </option>
      ))}
    </select>
  );
}
